import * as angular from "angular";
import template from "./entity-identifiers.html";
import "./entity-identifiers.less";
import { FORM_ENTITY_IDENTIFIERS } from "../../../../../../routes";
import { globs } from "../../../../../../services/globs";
import {
	Any,
	Pattern
} from "../../../../../../services/security/actionScopes";
import viewModesSection from "../../../../../view-modes-section";
import entityIdentifiersViewer from "./entity-identifiers-viewer/entity-identifiers-viewer";
import entityIdentifiersEditor from "./entity-identifiers-editor/entity-identifiers-editor";

export function controller(appState, loadingService, api, securityService) {
	const ctrl = this;
	let identifierActions;

	ctrl.loadIdentifiers = loadIdentifiers;
	ctrl.toggleIncludeInactive = toggleIncludeInactive;

	ctrl.$onInit = () => {
		ctrl.isLoading = false;
		ctrl.loadError = false;
		ctrl.includeInactive = false;
		ctrl.identifiers = [];
		identifierActions = globs.entityTypes
			.byType(ctrl.typeConfig.Code)
			.identifiers;

		const canViewPattern = identifierActions.byCode("*").read;
		ctrl.canViewIdentifiers = securityService.isActionOrPatternAllowed(canViewPattern);
		ctrl.canShowInactiveToggle = securityService.isActionScopeAllowed(new Any([
			new Pattern(identifierActions.byCode("*").deactivate),
			new Pattern(identifierActions.byCode("*").reactivate)
		]));

		if(ctrl.entity.Id && ctrl.canViewIdentifiers) {
			loadIdentifiers().catch(() => undefined);
		}
	};

	function loadIdentifiers() {
		const route = FORM_ENTITY_IDENTIFIERS(appState.forms.selected.Id, ctrl.entity.Id);

		ctrl.isLoading = true;
		const promise = api.get(route)
			.then(identifiers => {
				ctrl.identifiers = (identifiers ?? []).filter(identifier =>
					identifier.Type.Code !== "CODE"
						&& securityService.isActionAllowed(
							identifierActions.byCode(identifier.Type.Code).read
						)
				);
				ctrl.loadError = false;

				return ctrl.identifiers;
			})
			.catch(error => {
				ctrl.loadError = true;
				throw error;
			})
			.finally(() => {
				ctrl.isLoading = false;
			});

		return loadingService.watch(promise);
	}

	function toggleIncludeInactive() {
		ctrl.includeInactive = !ctrl.includeInactive;
	}
}

export default angular.module("vesl.components.entity-identifiers", [
	viewModesSection,
	entityIdentifiersViewer,
	entityIdentifiersEditor
])
	.component("entityIdentifiers", {
		controller,
		template,
		bindings: {
			entity: "<",
			readonly: "<",
			typeConfig: "<",
			put: "=",
			post: "=",
			initialMode: "<"
		}
	})
	.name;
